import classNames from 'classnames';
import {Check} from 'lucide-react';
import * as React from 'react';

export interface CheckboxProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    boxed?: boolean;
    id?: string;
    disabled?: boolean;
    className?: string;
    children: React.ReactNode;
}

export const Checkbox: React.FunctionComponent<CheckboxProps> = ({checked, onChange, boxed, id, disabled, className, children}: CheckboxProps) => (
    <label className={classNames('mp-checkbox', {'mp-checkbox--boxed': boxed}, className)}>
        <input
            type="checkbox"
            id={id}
            checked={checked}
            disabled={disabled}
            onChange={e => onChange(e.target.checked)}
        />
        <span className="mp-checkbox__box" aria-hidden="true">
            <Check size={14}/>
        </span>
        <span className="mp-checkbox__label">{children}</span>
    </label>
);
